import { render, staticRenderFns } from "./PointCreditLogView.vue?vue&type=template&id=3c2e317e&scoped=true"
import script from "./PointCreditLogView.vue?vue&type=script&lang=js"
export * from "./PointCreditLogView.vue?vue&type=script&lang=js"
import style0 from "./PointCreditLogView.vue?vue&type=style&index=0&id=3c2e317e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e317e",
  null
  
)

export default component.exports